import Image from "next/image";

import { cn } from "@/lib/utils";

export function Knit({ className }: { className?: string }) {
  return (
    <Image
      src="/company_logos/knit.svg"
      alt="Knit logo"
      width={800}
      height={346}
      className={cn(className, "w-auto brightness-0")}
    />
  );
}
